import createCalculateDecorator from 'final-form-calculate';
import createDecorator from 'final-form-focus';
import { EntityType } from '@qover-private/protos-web/qover/dojo/contracts/v1/policyholder';
import { getIn } from 'final-form';

export const calculatePolicyholderDeprecated = createCalculateDecorator({
  field: 'policyholder.type',
  updates: {
    'policyholder.person': (policyholderType, allValues: any) =>
      policyholderType !== 'company'
        ? allValues?.policyholder?.person
        : undefined,
    'policyholder.company': (policyholderType, allValues: any) =>
      policyholderType === 'company'
        ? allValues?.policyholder?.company
        : undefined,
    'policyholder.company.billingAddressSameAsCompany': (
      policyholderType,
      allValues: any,
    ) =>
      policyholderType === 'company'
        ? !allValues?.policyholder?.company?.address
        : undefined,
    'policyholder.company.address.country': policyholderType =>
      policyholderType === 'company' ? 'BE' : undefined,
  },
});

export const calculatePolicyholder = createCalculateDecorator({
  field: 'policyholder.entityType',
  updates: {
    'policyholder.billingAddressSameAsCompany': (
      policyholderType,
      allValues: any,
    ) => {
      if (policyholderType === EntityType.ENTITY_TYPE_COMPANY) {
        if (!allValues?.policyholder?.billingAddress) {
          return true;
        }

        const { country, ...restBillingAddress } =
          allValues?.policyholder?.billingAddress ?? {};

        if (Object.keys(restBillingAddress).length > 0) {
          return false;
        }
      }

      return undefined;
    },
  },
});

export const calculateBillingAddressDeprecated = createCalculateDecorator({
  field: 'policyholder.company.billingAddressSameAsCompany',
  updates: {
    'policyholder.company.address': (
      billingAddressSameAsCompany,
      allValues: any,
    ) =>
      allValues?.policyholder?.type === 'person' || billingAddressSameAsCompany
        ? undefined
        : {
            country: 'BE',
            ...(allValues?.policyholder?.company?.address ?? {}),
          },
  },
});

export const calculateBillingAddress = createCalculateDecorator({
  field: 'policyholder.billingAddressSameAsCompany',
  updates: {
    'policyholder.billingAddress': (
      billingAddressSameAsCompany,
      allValues: any,
    ) =>
      allValues?.policyholder?.entityType === EntityType.ENTITY_TYPE_PERSON ||
      billingAddressSameAsCompany
        ? undefined
        : allValues?.policyholder?.billingAddress || {
            country: allValues?.policyholder?.address?.country,
          },
  },
});

export const updateCountry = createCalculateDecorator({
  field: 'refs.country',
  updates: {
    'policyholder.address.country': (country: string, allValues: any) => {
      if (country !== allValues?.policyholder?.address?.country) {
        return country;
      }
      return allValues?.policyholder?.address?.country;
    },
    'policyholder.billingAddress.country': (
      country: string,
      allValues: any,
    ) => {
      const policyholder = allValues?.policyholder;

      if (policyholder?.entityType === EntityType.ENTITY_TYPE_PERSON) {
        return undefined;
      }
      if (
        !policyholder?.billingAddressSameAsCompany &&
        country !== policyholder?.billingAddress?.country
      ) {
        return country;
      } else if (!policyholder?.billingAddressSameAsCompany) {
        return policyholder?.address?.country;
      }
      return undefined;
    },
  },
});

const findInput = (inputs: any, errors: any) => {
  const invalidField = inputs.find((input: any) => {
    const name = input.name || input.dataset.name;
    return name && getIn(errors, name);
  });

  if (invalidField) {
    invalidField.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }

  return invalidField;
};

export const focusOnError = createDecorator(undefined, findInput);
